/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_F_AddressInputs */

const cs_pm_f_address = /** @type {(inputs: Pm_F_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa`)
};

const en_pm_f_address = /** @type {(inputs: Pm_F_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Pm_F_AddressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_f_address = /** @type {((inputs?: Pm_F_AddressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_F_AddressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_f_address(inputs)
	return cs_pm_f_address(inputs)
});